import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'pending',
    name: 'pending',
    component: () => import('@/layout/routerView.vue'),
    redirect: '/pending/production',
    meta: { title: '待办事项', icon: 'svg:menu-todo', order: 10 },
    children: [
      { path: 'production', name: 'todo_submit', component: () => import('@/views/Production/Value/pending.vue'), meta: { title: '待提报的日产值' } },
    ]
  },
  {
    path: 'production',
    name: 'production',
    component: () => import('@/layout/routerView.vue'),
    redirect: '/production/value',
    meta: { title: '产值管理', icon: 'svg:menu-output', order: 80 },
    children: [
      { path: 'value', name: 'production_value', component: () => import('@/views/Production/Value/index.vue'), meta: { title: '日产值数据' } },
      { path: 'rank', name: 'production_rank', component: () => import('@/views/Production/Rank/index.vue'), meta: { title: '日产值排名' } },
      { path: 'reconcile', name: 'production_reconcile', component: () => import('@/views/Production/Reconcile/index.vue'), meta: { title: '产值对账' } },
      { path: 'qd-target', name: 'production_qd_target', component: () => import('@/views/Production/QdTarget/index.vue'), meta: { title: '区队月目标产值' } },
      { path: 'qy-target', name: 'production_qy_target', component: () => import('@/views/Production/QyTarget/index.vue'), meta: { title: '区域月目标产值' } },
      { path: 'dq-target', name: 'production_dq_target', component: () => import('@/views/Production/DqTarget/index.vue'), meta: { title: '大区月目标产值' } },
      { path: 'zq-target', name: 'production_zq_target', component: () => import('@/views/Production/ZqTarget/index.vue'), meta: { title: '战区月目标产值' } }
    ]
  }
]

export default routes
